import React from "react";
import {
  ElementWrapper,
  ElementWrapperInner,
  ElementName,
  ElementNumber,
  ElementSymbol,
  ElementWeight
} from "./styled";

const PeriodicElement = props => (
  <ElementWrapper>
    <ElementWrapperInner>
      <ElementName>{props.name}</ElementName>
      <ElementNumber>{props.number}</ElementNumber>
      <ElementSymbol>{props.symbol}</ElementSymbol>
      <ElementWeight>{props.weight}</ElementWeight>
    </ElementWrapperInner>
  </ElementWrapper>
);

export default PeriodicElement;



// WEBPACK FOOTER //
// ./src/pages/Materials/MaterialComponent/PeriodicElement.js